@import '../../../../../constants/spacing.module.less';

.warning-pill {
  display: inline-flex;
  align-items: center;
  cursor: default;
}

.warning-icon {
  color: var(--yellow-600);
  margin-right: @space-4;
}

.warning-text {
  font-weight: 600;
}
